export default "__VITE_ASSET__qHhCKSV9__"